import Rx from 'rxjs';
import React from 'react';
// import { DateRange } from 'react-date-range';
import client from 'utils/Contentful';
import $ from 'jquery';

import { getImage } from 'utils/Contentful';
import { HFBlock } from 'components';

import {
  Chooser,
  CaseDemo,
} from './components';

import * as localeMap from './locale';
import {
  mapEntry,
  filterCase,
  listLocaleMap,
} from './helper';

import "./case-page.css";
// import 'react-date-range/dist/styles.css';
// import 'react-date-range/dist/theme/default.css';

class CasePage extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      images: {
        kv: []
      },
      filter: {
        keyword: "",
        type: {indexList: []},
        client: {indexList: []},
        during: {
          startDate: new Date(),
          endDate: new Date(),
          key: 'selection',
        },
      },
      list: [],
      openFilter: "",
    };
  }
  componentDidMount() {
    this.setImage();
    document.addEventListener('click', this.closeFilter);

    client.getEntries({
      'limit': 500,
      'locale': this.props.localeCode,
      'order': 'fields.id',
      'content_type': 'case',
    }).then((entries) => {
      const { locale } = this.props;
      // item.fields.xxx ← 裡面包含了語系
      const list = entries.items.map(item => mapEntry({item, locale}));
      this.setState({ list });

      // setTimeout(() => {
      const keyword = Rx.Observable.fromEvent(this.input, 'input');
      this.inputObs = keyword
        .debounceTime(250)
        .subscribe(e => {
          console.warn(e);
          this.setState({
            filter: {
              ...this.state.filter,
              keyword: e.target.value
            }
          });
        });
    }, (err) => {
      console.log('Something went wrong: ', err);
    });

  }

  componentWillUnmount() {
    document.removeEventListener('click', this.closeFilter);
    if(this.inputObs) this.inputObs.unsubscribe();
  }

  toggleList = (openFilter) => {
    if(this.state.openFilter === openFilter) openFilter = "";
    this.setState({ openFilter });
  }

  toogleIndex = ({attr, indexList}) => {
    const { filter } = this.state;
    this.setState({
      filter: {
        ...filter,
        [attr]: { indexList }
      }
    });
  }

  handleRangeChange = (payload) => {
    this.setState({
      filter: {
        ...this.state.filter,
        during: payload.selection,
      }
    });
  }

  closeFilter = (e) => {
    if(!$(e.target).closest('.chooser') && e.target.id !== 'lang')
      this.setState({ openFilter: "" });
  }

  setImage = () => {
    getImage('Case').then(({kv}) => {
      this.setState({
        images: {
          kv: kv.map(item =>
            item ? item.fields.file.url : ""
          )
        }
      });
    })
  }

  render () {
    const { locale } = this.props;
    const lang = localeMap[locale];
    const {
      typeList,
      clientList,
    } = listLocaleMap({
      locale,
      caseList: this.state.list
    });
    const {
      list,
      openFilter,
      images: { kv },
      filter: {
        type,
        client,
        keyword,
        during,
      }
    } = this.state;
    const caseList = filterCase({
      caseList: list,
      filter: {
        type: {list: typeList, indexList: type.indexList},
        client: {list: clientList, indexList: client.indexList},
        keyword,
      },
      locale,
      during,
    });

    return (
      <HFBlock
        className="case-page"
        {...this.props}
      >
        <div className="kv" style={{backgroundImage: kv[0] ? `url(${kv[0]})` : ""}}>
          <div className="container">
            <div className="heading">{lang.heading}</div>
          </div>
        </div>
        <div className="container">
          <div className="filter">
            <Chooser
              attr="type"
              locale={locale}
              isOpen={openFilter === "type"}
              text={lang.filter.type}
              itemList={typeList}
              indexList={type.indexList}
              toggleList={this.toggleList}
              toogleIndex={this.toogleIndex}
            />
            <Chooser
              attr="client"
              locale={locale}
              isOpen={openFilter === "client"}
              text={lang.filter.client}
              itemList={clientList}
              indexList={client.indexList}
              toggleList={this.toggleList}
              toogleIndex={this.toogleIndex}
            />
            {/* <div className={`chooser ${openFilter === "during" && "open"}`}>
              <span
                className="text"
                onClick={this.toggleList.bind(this, 'during')}
              >
                {lang.filter.during}
              </span>
              {openFilter === "during" &&
                <DateRange
                  className="date-ranger"
                  onChange={this.handleRangeChange}
          				ranges={[during]}
                  maxDate={new Date()}
          			/>
              }
            </div> */}
            <input type="text" ref={(ref) => this.input = ref} />
          </div>
          <div className="row case-block">
            {caseList.length ?
              caseList.map(item =>
                <div key={item.id} className="col-md-4">
                  <CaseDemo {...item} />
                </div>
              ):
              <div className="loading-block">Loading</div>
            }
          </div>
        </div>
      </HFBlock>
    );
  }
}

export default CasePage;



// WEBPACK FOOTER //
// ./src/pages/CasePage/index.js